import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);

  return (
    <div className="page-wrapper">

      <Header />

      <div className="main-content">
        <Outlet />
      </div>

      <Footer />

    </div>
  );
};

export default Layout;
